// Запуск после загрузки документа, как автозапуск AngularJS по атрибуту ng-app: к этому моменту
// выполнены все скрипты страницы. animations: false — классы меняются сразу, без анимаций.
import { installAccessibility } from '../runtime/a11y';

export function startWhenReady(angular, options = {}) {
    const start = () => {
        // Город и локаль доставки из layout.
        const values = document.getElementById('site-values');
        const { locale_config: locale, city } = values ? JSON.parse(values.textContent) : {};
        angular.module('myApp').value('locale_config', locale).value('city', city || {});
        const root = document.querySelector('[ng-app]') || document.documentElement;
        try {
            angular.$$bootstrap(root, options);
        } finally {
            // Роли, подписи и alt не меняют вид; они нужны программам чтения экрана и поисковикам.
            installAccessibility(document);
        }
    };
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        setTimeout(start, 0);
    }
}
